import React, { useEffect, useState } from "react";

import OtherInfo from "./OtherInfo";
import Posts from "./Posts";
// import Saved from './Saved'

import { useSelector, useDispatch } from "react-redux";
import LoadIcon from "../../../../assests/loading.gif";
import { getProfileUsers } from "../../../../redux/actions/profileAction";
import { useParams } from "react-router-dom";

const OtherProfile = () => {
  const { profile, auth } = useSelector((state) => state);
  const dispatch = useDispatch();

  const { id } = useParams();
  const [saveTab, setSaveTab] = useState(false);

  useEffect(() => {
    dispatch(getProfileUsers({ id, auth }));
  }, [id, auth, dispatch]);

  return (
    <div className="profile">
      <OtherInfo auth={auth} profile={profile} dispatch={dispatch} id={id} />

      {auth.user._id === id && (
        <div className="profile_tab">
          <button
            className={saveTab ? "" : "active"}
            onClick={() => setSaveTab(false)}
          >
            Posts
          </button>
        </div>
      )}

      {profile.loading ? (
        <img className="d-block mx-auto" src={LoadIcon} alt="loading" />
      ) : (
        <>
          <Posts auth={auth} profile={profile} dispatch={dispatch} id={id} />
        </>
      )}
    </div>
  );
};

export default OtherProfile;
